import { render, staticRenderFns } from "./ThemeStyles.vue?vue&type=template&id=22e4811a"
import script from "./ThemeStyles.vue?vue&type=script&lang=js"
export * from "./ThemeStyles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports